import styles from './styles.module.css';
import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import SearchBar from '@components/searchBar';

import Export from '@pages/SelloutMonitoring/components/export';
import Resync from '@pages/SelloutMonitoring/components/resync';
import FilterList from '@pages/SelloutMonitoring/components/filter/filterList';
import FilterButton from '@pages/SelloutMonitoring/components/filter/filterButton';
import { debounce } from '@helpers/utils';
import { useFilter } from '@pages/SelloutMonitoring/hooks/state/filters';
import { useGlobalFilter } from '@pages/SelloutMonitoring/hooks/state/globalFilter';

const Filter = () => {
    const { setFilter } = useFilter();
    const { group, customer } = useGlobalFilter();
    const selectedGroup = group?.name ?? '';
    const selectedCustomer = customer?.name ?? '';
    const { isOpen: isOpenFilter, onClose: onCloseFilter, onOpen: onOpenFilter } = useDisclosure();

    const onChangeSearch = (e) => {
        setFilter({ page: 1, search: e.target.value });
    };

    return (
        <>
            <Flex flexDirection="row" alignItems="center" gap="8px" fontSize={'xl'} fontWeight={'bold'} mb="16px">
                <Text>Data Sellout</Text>
                <Text>
                    {selectedGroup} {!!selectedGroup && !!selectedCustomer ? '-' : ''} {selectedCustomer}
                </Text>
            </Flex>

            <Box className={styles.head}>
                <Flex justify="space-between">
                    <Flex gap="24px" me={'24px'}>
                        <SearchBar placeholder="Cari data sellout" onChange={debounce(onChangeSearch)} />
                        <FilterButton isOpen={isOpenFilter} onClose={onCloseFilter} onOpen={onOpenFilter} />
                        <Export />
                    </Flex>
                    <Resync />
                </Flex>
                <FilterList isOpen={isOpenFilter} onClose={onCloseFilter} onOpen={onOpenFilter} />
            </Box>
        </>
    );
};

export default Filter;
